import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Header } from '@hz-design-system/web-ui';
import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';

import '../../../scss/landingPage.scss';
import SearchFeedApp from '../../apps/SearchFeed/SearchFeedApp';
import HeroApp from '../../apps/Hero/HeroApp';
import { trackGAEvent } from '../../utils/gaTracking';
import BudgetApp from '../../apps/Landingpage/components/Budget';
import CopyApp from '../../apps/Landingpage/components/Copy';

// eslint-disable-next-line require-await
export default async (i18n) => {
  const appState = window.__CONFIG__ || {
    searchResult: {},
    searchCategories: {},
    searchFilters: {},
  };
  const environment = window.__ENV_CONFIG__ || {
    pageKey: '',
  };
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const backgroundRoot = document.getElementById('background-root');
  const budgetRoot = document.getElementById('budget-root');
  const copyRoot = document.getElementById('copy-root');
  const searchFeedRoot = document.getElementById('search-feed-root');

  // Header is server side rendered in express-react library
  hydrateRoot(headerRoot!, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);

  hydrateRoot(backgroundRoot!, <HeroApp pageKey={environment.pageKey} environment={environment} />);

  if (budgetRoot) {
    hydrateRoot(budgetRoot!, <BudgetApp />);
  }

  if (copyRoot) {
    hydrateRoot(copyRoot!, <CopyApp environment={environment} />);
  }

  hydrateRoot(
    searchFeedRoot!,
    <I18nContextProvider i18nInstance={i18n}>
      <SearchFeedApp
        environment={environment}
        searchResult={appState.searchResult}
        searchCategories={appState.searchCategories}
        searchFilters={appState.searchFilters}
        searchLink={appState.searchLink}
      />
    </I18nContextProvider>,
  );
};
